<template>
<div id="representantes">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Solicitud Consulta de Pedimentos" class="elevation-1 px-5 py-3">
                    <v-card-actions>
                        <v-btn small dark color="red" v-if="datafiltered.length > 0" @click.native="eliminar_todos" title="Eliminar Todos los registros de la lista" v-tippy>
                            <v-icon>mdi-trash-can-outline</v-icon> Eliminar Todos
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary">
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="consulta.camposexcel" :name="getNameExcel">
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel :data="consulta.camposLayout" :exportFields="consulta.encabezadoLayout" name="Layout Solicitud Pedimentos.xlsx">
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid">

                            <v-client-table ref="vuetable" :data="consulta.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props">
                                    <v-btn x-small fab dark color="orange" v-if="props.row.estatus=='pendiente' || props.row.estatus=='en cola'" @click.native="consultarPedimento(props.row.rfc, props.row.fechaCompleta)" title="Actualizar Estatus" v-tippy>
                                        <v-icon>refresh</v-icon>
                                    </v-btn> &nbsp;
                                    <v-btn x-small fab dark color="blue" v-if="(props.row.finalizado==0 && props.row.estatus!='recuperado' && props.row.estatus!='pendiente' && props.row.estatus!='en cola' 
                          && (props.row.respuesta!=null? props.row.respuesta.indexOf('pedimento no fue localizado')== -1 : true)) " @click.native="recuperarPedimento(props.row.rfc, props.row.fechaCompleta)" title="Volver a Recuperar" v-tippy>
                                        <v-icon>send</v-icon>
                                    </v-btn>

                                </template>
                            </v-client-table>
                        </div>
                        <!--div>
                            <v-card class="default " style="font-size:11px;" >
                                <span class="" >
                                    <strong>ESTATUS<br />
                                        Pendiente:</strong> Pendiente de encolar para su recuperación.<br />
                                    <strong>En cola:</strong> Ya encolado para su recuperación.<br />
                                    <strong>Recuperado:</strong> XML ya recuperado.<br />
                                    <strong>Error:</strong> Ocurrió un error al recuperar.<br />
                                    <strong>No recuperable:</strong> El pedimento no es recuperable.<br />
                                </span>
                            </v-card>
                        </div-->
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import GridLoader from "vue-spinner/src/GridLoader.vue";
export default {
    components: {
        loader: GridLoader
    },

    data: () => ({
        fab: false,
        eliminar: [],
        name: "datagrid",
        importData: [],
        columns: [
            "id",
            "fecha",
            "pedimento",
            "patente",
            "aduana",
            "anio",
            "estatus",
            "respuesta",
            "actions"
        ],
        show_loading: true,
        options: {
            filterable: [
                "id",
                "fecha",
                "pedimento",
                "patente",
                "aduana",
                "anio",
                "estatus",
                "respuesta",
            ],
            sortable: [
                "id",
                "fecha",
                "pedimento",
                "patente",
                "aduana",
                "anio",
                "estatus",
                "respuesta",
            ],

            headings: {
                id: "No. Proceso",
                fecha: "Fecha de Solicitud",
                pedimento: "Pedimento",
                patente: "Patente",
                aduana: "Aduana",
                anio: "Año de Pedimento",
                estatus: "Estatus",
                respuesta: "Respuesta WS",
                actions: "Operaciones"
            },

        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Vucem-Pedimento",
                disabled: true,
                to: ""
            },
            {
                text: "Solicitud de Consulta Pedimentos",
                disabled: true,
                to: ""
            }
        ],

        consulta: {
            selected: [],
            camposexcel: {
                "Fecha de Solicitud": "fecha",
                "Pedimento": "pedimento",
                "Patente": "patente",
                "Aduana": "aduana",
                "Año de Pedimento": "anio",
                "Estatus": "estatus",
                "Respuesta": "respuesta",
            },
            items: [],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                pedimento: "pedimento",
                patente: "patente",
                aduana: "aduana",
                anio: "anio",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                pedimento: "[Número de pedimento]",
                patente: "[Número de patente del pedimento]",
                aduana: "[Número de aduana del pedimento - 2 digitos]",
                anio: "[Año del Pedimento]",
            }]
        },
        camposObligatorios: [
            "pedimento",
            "patente",
            "aduana",
            "anio",
        ],
    }),
    computed: {
        getNameExcel() {
            return "ConsultaPedimentos_" + this.$local_storage.get("rfc") + ".xlsx";
        },
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.consulta.items;
            }

        },
    },

    methods: {
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        eliminar_todos() {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar : " + this.datafiltered.length + " registros ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    let self = this;
                    let lista = [];
                    self.eliminar = [];
                    let id = "";
                    this.datafiltered.forEach(function (x) {
                        if (x.id != id) {
                            self.eliminar.push({
                                "id_documento": x.id,
                                "rfc": self.$local_storage.get("rfc"),
                                "lista": []
                            });
                            id = x.id;
                            lista = [];
                        }
                    });
                    this.datafiltered.forEach(function (x) {
                        const ix = self.eliminar.findIndex(t => t.id_documento == x.id);
                        self.eliminar[ix].lista.push({
                            "aduana": x.aduana,
                            "patente": x.patente,
                            "pedimento": x.pedimento,
                            "anio": x.anio
                        });

                    });
                    let z = 1;
                    self.eliminar.forEach(function (data) {
                        axios
                            .post(self.$hostname + "consulta_pedimento/eliminar_pedimento_peticion/", data)
                            .then(res => {
                                if (z == self.eliminar.length) {
                                    self.cargar();
                                    self.$swal({
                                        type: "success",
                                        title: "Operación Exitosa",
                                        text: "Los registros se eliminaro correctamente",
                                        footer: ""
                                    });
                                    self.$refs.vuetable.resetQuery();
                                    self.$root.$dialogLoader.hide();
                                }

                                z = z + 1;
                            })
                            .catch(err => {
                                self.$root.$dialogLoader.hide();
                            });
                    });

                }
            });

        },
        cargar: function () {
            var datos = {
                rfc: this.$local_storage.get("rfc")
            };
            this.consulta.items = [];
            axios
                .post(this.URL + "get_consultas/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        var pedimentos = [];
                        for (var k in res.data) {
                            pedimentos = res.data[k]['pedimentos'];
                            for (var key in pedimentos) {
                                var item = {};
                                item['fecha'] = this.parseDate(res.data[k]['fecha']);
                                item['fechaCompleta'] = res.data[k]['fecha'].replace("T", " ");
                                item['rfc'] = res.data[k]['rfc'];
                                item['finalizado'] = res.data[k]['finalizado'];
                                item['pedimento'] = pedimentos[key]['pedimento'];
                                item['patente'] = pedimentos[key]['patente'];
                                item['aduana'] = pedimentos[key]['aduana'];
                                item['anio'] = pedimentos[key]['anio'];
                                item['estatus'] = pedimentos[key]['estatus'];
                                item['respuesta'] = pedimentos[key]['respuesta'];
                                item['id'] = res.data[k]['id'];
                                this.consulta.items.push(item);
                            }
                        }

                        this.consulta.items.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fechaCompleta) - new Date(a.fechaCompleta);
                        });

                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {

                    //console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },

        cargarAduanas: function () {
            axios
                .get(this.$hostname + "catalogos/aduanas/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.aduanas = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de aduanas",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de aduanas.",
                        footer: ""
                    });
                    //console.log(err);
                });
        },

        obtenerAduana(id_aduana) {
            let aduanas = this.aduanas.filter(function (e) {
                return e.id_aduana == id_aduana;
            });
            return aduanas.length > 0 ? (aduanas[0].clave + " - " + aduanas[0].nombre) : "N/A";
        },
        verificaAduana: function (aduana, opcion) {
            if (aduana == undefined)
                return false;

            var search = this.aduanas.filter(function (e) {
                return parseInt(e.clave.toString().trim()) == parseInt(aduana.toString().trim());
            });
            if (opcion == 'id')
                return search.length > 0 ? search[0].clave : '';
            else
                return search.length > 0;
        },

        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else {
                    for (var k in results) {

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            if (results[k]["anio"] != undefined && (!Number.isInteger(results[k]["anio"]) || results[k]["anio"].toString().trim().length != 4)) {
                                errores++;
                                erroresText += "<br>- El año \"" + results[k]["anio"] + "\" debe ser un número entero de 4 dígitos.";
                            }
                            if (results[k]["pedimento"] != undefined && (results[k]["pedimento"].toString().trim().length > 7 || !parseInt(results[k]["pedimento"]) > 0)) {
                                errores++;
                                erroresText += "<br>- El número de pedimento \"" + results[k]["pedimento"] + "\" debe ser un número entero de máximo 7 dígitos.";
                            } else {
                                results[k]["pedimento"] = results[k]["pedimento"].toString().trim().padStart(7, '0');
                            }
                            if (results[k]["patente"] != undefined && (results[k]["patente"].toString().trim().length > 4 || !parseInt(results[k]["patente"]) > 0)) {
                                errores++;
                                erroresText += "<br>- El número de patente \"" + results[k]["patente"] + "\" debe ser un número entero de máximo 4 dígitos.";
                            } else {
                                results[k]["patente"] = results[k]["patente"].toString().trim().padStart(4, '0');
                            }
                            if (results[k]["aduana"] != undefined && !thisObject.verificaAduana(results[k]["aduana"])) {
                                errores++;
                                erroresText += "<br>- La aduana \"" + results[k]["aduana"] + "\" no existe en el sistema.";
                            }

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                //console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];

            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {

                    for (var k in results) {
                        var aduana = this.verificaAduana(results[k]["aduana"], "id");
                        this.importData.push({
                            pedimento: results[k]["pedimento"].toString().trim(),
                            patente: results[k]["patente"].toString().trim(),
                            aduana: aduana.toString().trim(),
                            anio: results[k]["anio"],
                        });
                    }

                    let datos = {
                        rfc: this.$local_storage.get("rfc"),
                        fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
                        usuario: this.$local_storage.get("id_usuario"),
                        pedimentos: this.importData,
                        origen: "Recuperaciones Layout"
                    };

                    //console.log(datos);

                    axios
                        .post(this.URL + "save_consulta/", datos)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El layout se cargó correctamente. Recibirá una notificación cuando el resultado esté disponible.",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            //console.log(err.response);
                            var errores = "";
                            if (err.response.data != undefined) {
                                if (err.response.data.mensaje != undefined) {
                                    if (typeof err.response.data.mensaje == "string")
                                        errores += err.response.data.mensaje;
                                    else
                                        errores += err.response.data.mensaje[0];

                                } else {
                                    Object.keys(err.response.data).forEach(function (key) {
                                        errores += key + ": " + err.response.data[key];
                                        errores += "<br>";
                                    });

                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        consultarPedimento: function (rfc, fecha) {
            let datos = {
                rfc: rfc,
                fecha: fecha,
                usuario: this.$local_storage.get("id_usuario"),
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            axios
                .post(this.URL + "actualiza_consulta/", datos)
                .then(() => {})
                .catch(err => {
                    var errores = "";
                    if (err.response.data != undefined) {
                        if (err.response.data.mensaje != undefined) {
                            if (typeof err.response.data.mensaje == "string")
                                errores += err.response.data.mensaje;
                            else
                                errores += err.response.data.mensaje[0];

                        } else {
                            Object.keys(err.response.data).forEach(function (key) {
                                errores += key + ": " + err.response.data[key];
                                errores += "<br>";
                            });

                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al verificar la consulta.",
                        footer: errores
                    });
                })
                .then(() => {
                    this.cargar();
                });
        },
        recuperarPedimento: function (rfc, fecha) {
            let datos = {
                rfc: rfc,
                fecha: fecha,
                usuario: this.$local_storage.get("id_usuario"),
                origen: "Recuperaciones Layout"
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            axios
                .post(this.URL + "verifica_consulta/", datos)
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Recibirá una notificación cuando el resultado esté disponible.",
                        footer: ""
                    });
                })
                .catch(err => {
                    var errores = "";
                    if (err.response.data != undefined) {
                        if (err.response.data.mensaje != undefined) {
                            if (typeof err.response.data.mensaje == "string")
                                errores += err.response.data.mensaje;
                            else
                                errores += err.response.data.mensaje[0];

                        } else {
                            Object.keys(err.response.data).forEach(function (key) {
                                errores += key + ": " + err.response.data[key];
                                errores += "<br>";
                            });

                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al verificar la consulta.",
                        footer: errores
                    });
                })
                .then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        }
    }, //methods

    created: function () {
        //this.URL = this.$hostname + "consulta_pedimento/";
        this.URL = "https://apivucem.econnectpro.mx/consulta_pedimento/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();
        this.cargarAduanas();
    }
};
</script>
